import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=736306f5"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
import style0 from "./Comment.vue?vue&type=style&index=0&id=736306f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports